
export default{
    // @StandardPricing
    newCreatedStandardPricingMaster: {},
    newCreatedStandardPricing: {}
}